// 过滤器
export const filters = {
  formatPrice: value => {
  if(value === 0){
    return 0
  }
      if(!value){
          return;
      }
  return    parseFloat((+value).toFixed(2));
  },
}